// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
    border-radius: 10px;
  }
  .small-box {
    text-align: center;
    border-radius: 10px;
  }
  .btn {
    font-size: 1.2rem;
    padding: 10px;
    border-radius: 5px;
  }

.btn-dark-red {
  background-color: transparent;
  color: white;
  border-color: white;
}
.btn-dark-red:hover {
  color: #bd0000;
  background-color: rgba(255, 255, 255, 0.7);
}`, "",{"version":3,"sources":["webpack://./src/app/modules/trainer-dashboard/trainer-dashboard.component.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,aAAa;IACb,kBAAkB;EACpB;;AAEF;EACE,6BAA6B;EAC7B,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,0CAA0C;AAC5C","sourcesContent":[".card {\n    border-radius: 10px;\n  }\n  .small-box {\n    text-align: center;\n    border-radius: 10px;\n  }\n  .btn {\n    font-size: 1.2rem;\n    padding: 10px;\n    border-radius: 5px;\n  }\n\n.btn-dark-red {\n  background-color: transparent;\n  color: white;\n  border-color: white;\n}\n.btn-dark-red:hover {\n  color: #bd0000;\n  background-color: rgba(255, 255, 255, 0.7);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
